declare global {
  interface Window {
    __BASE_PATH__?: string;
  }
}

/** Base path for API and router when the app is served under a path prefix (e.g. /status-admin). Set by the server-injected script in index.html. */
export function getBasePath(): string {
  if (typeof window === "undefined") return "";
  return window.__BASE_PATH__ ?? "";
}
